export default __webpack_public_path__ + "static/media/profile-2026.64eccc82.png";